export const PACKAGE = {
  STATUSES: {
    PENDINGENTRYPAQUERY: 1,
    ARRIVEDATPAQUERYPOINT: 2,
    INHANDSOFPAQUER: 3,
    ONWAY: 4,
    PENDINGSCHEDULE: 5,
    PENDINGPREPARATION: 6,
    ACCEPTEDBYPAQUER: 7,
    AVAILABLEFORPICKUP: 8,
    COLLECTED: 9,
    DELIVEREDPENDINGSIGNATURE: 19,
    DELIVERED: 20,
    CANCELLED: 21,
    LOGGEDINTOPAQUERY: 22,
    PENDINGENTRYPAQUERYPOINT: 23,
    AVAILABLEINSTORE: 24,
    WRONGADDRESS: 25,
    UNREACHABLEZONE: 26,
    DELIVERYCONTINGENCY: 27,
    DAMAGED: 28,
    NOTOPERATED: 29,
    PENDINGPAYMENT: 30,
    DELIVERYATTEMPTONE: 31,
    DELIVERYATTEMPTTWO: 32,
    INRETURNPROCESS: 39,
    RETURNED: 40,
    EXPIRED: 50,
    INGRESSBYEXTERNALOPERATION: 60,
  },
  TYPES: {
    RECEIVE: 1,
    SEND: 2,
    PICKUP: 3,
    DIRECT: 4,
    FLEX: 5,
  },
  SIZES: {
    UNKNOWN: 0,
    SMALL: 1,
    MEDIUM: 2,
    BIG: 3,
    CUSTOM: 4,
  },
  TERMS: {
    TWODAYS: 1,
    NEXTDAY: 2,
    SAMEDAY: 3,
    TWOHOURS: 4,
    ONEWEEK: 5,
  },
};

export const allowedSendPackageTypes = [
  PACKAGE.TYPES.SEND,
  PACKAGE.TYPES.PICKUP,
  PACKAGE.TYPES.DIRECT,
  PACKAGE.TYPES.FLEX,
];

export const finalStatuses = [
  PACKAGE.STATUSES.DELIVERED,
  PACKAGE.STATUSES.CANCELLED,
  PACKAGE.STATUSES.DAMAGED,
  PACKAGE.STATUSES.RETURNED,
];

export const isFinalStatus = (statusId) => {
  return finalStatuses.includes(statusId);
};

const readyForDeliveryStatuses = [
  PACKAGE.STATUSES.ARRIVEDATPAQUERYPOINT,
  PACKAGE.STATUSES.AVAILABLEINSTORE,
];

export const isReadyForDeliveryStatus = (statusId) => {
  return readyForDeliveryStatuses.includes(statusId);
};

const arrivableStatuses = [
  PACKAGE.STATUSES.DELIVERED,
  PACKAGE.STATUSES.CANCELLED,
  PACKAGE.STATUSES.LOGGEDINTOPAQUERY,
  PACKAGE.STATUSES.DELIVERYATTEMPTONE,
  PACKAGE.STATUSES.DELIVERYATTEMPTTWO,
];

export const isArrivableStatus = (statusId) => {
  return arrivableStatuses.includes(statusId);
};

const unusedOnTransitStatuses = [
  PACKAGE.STATUSES.PENDINGSCHEDULE,
  PACKAGE.STATUSES.ONWAY,
  PACKAGE.STATUSES.DELIVERED,
  PACKAGE.STATUSES.DELIVEREDPENDINGSIGNATURE,
  PACKAGE.STATUSES.CANCELLED,
  PACKAGE.STATUSES.RETURNED,
  PACKAGE.STATUSES.WRONGADDRESS,
  PACKAGE.STATUSES.UNREACHABLEZONE,
  PACKAGE.STATUSES.DELIVERYCONTINGENCY,
  PACKAGE.STATUSES.PENDINGPAYMENT,
  PACKAGE.STATUSES.EXPIRED,
  PACKAGE.STATUSES.DAMAGED,
];

export const isOnTransitStatus = (statusId) => {
  return !unusedOnTransitStatuses.includes(statusId);
};

const unusedSendStatuses = [
  ...unusedOnTransitStatuses,
  PACKAGE.STATUSES.AVAILABLEINSTORE,
];

export const isSendStatus = (statusId) => {
  return !unusedSendStatuses.includes(statusId);
};

const unusedDirectStatuses = [
  ...unusedOnTransitStatuses,
  PACKAGE.STATUSES.LOGGEDINTOPAQUERY,
];

export const isDirectStatus = (statusId) => {
  return !unusedDirectStatuses.includes(statusId);
};
